import { useQuery } from '@tanstack/react-query';
import { useSessionStore } from '@/entities/session';
import { useAppSettingsStore } from '@/shared/lib';
import { CACHE_TIME_10_MINUTES, CACHE_TIME_5_MINUTES } from '@/shared/config';
import { getBankDepositBanksRequest } from '../requests';
import type { BankDepositBanksResponse } from '../types';

export function useBankDepositBanks(countryCode: string, currencyCode: string) {
  const { session } = useSessionStore();
  const { getLanguage } = useAppSettingsStore();
  const locale = getLanguage();

  const query = useQuery<BankDepositBanksResponse, Error>({
    queryKey: [
      'bankDepositBanks',
      session?.userId,
      locale,
      countryCode,
      currencyCode,
    ],
    queryFn: () => getBankDepositBanksRequest(countryCode, currencyCode),
    enabled: !!countryCode && !!currencyCode,
    staleTime: CACHE_TIME_5_MINUTES,
    gcTime: CACHE_TIME_10_MINUTES,
    retry: 1,
  });

  return {
    banks: query.data?.banks ?? [],
    isBanksLoading: query.isLoading,
    isBanksFetching: query.isFetching,
    isBanksError: query.isError,
    banksError: query.error,
  };
}
